<template>
    <v-layout column align-center>
        <p class="headline font-weight-bold mb-3 text-center primary--text">
            Selecting a route
        </p>
        <p class="align-self-start">
            Select your route by selecting the transit company that runs it, the route's name, and the direction it travels
        </p>
        <img v-if="$vuetify.breakpoint.xs" src="@/assets/help/companies_mobile.png" />
        <img v-else src="@/assets/help/companies.png" />
        <span class="caption">
            Using the drop-downs. Note that if only one company services the stop you have chosen, it will automatically be selected.
        </span>
        <img v-if="$vuetify.breakpoint.xs" src="@/assets/help/routes_mobile.png" />
        <img v-else src="@/assets/help/routes.png" />
        <span class="caption">
            You can click timetable to view the timetable for your stop
        </span>
        <img v-if="$vuetify.breakpoint.xs" src="@/assets/help/timetable_mobile.png" />
        <img v-else src="@/assets/help/timetable.png" />
        <span class="caption">
            The column highlighted in pink color shows the scheduled times for your stop. Notice that you can switch between services, such as weekday/weekend services, with the upper left tabs
        </span>
        <img v-if="$vuetify.breakpoint.xs" src="@/assets/help/timetable_popup_mobile.png" />
        <img v-else src="@/assets/help/timetable_popup.png" />
    </v-layout>
</template>

<script>
export default {
  data: () => ({

  }),
};
</script>
<style scoped>
  >>>img {
    border:1px solid black;
    max-width:100%;
  }

    >>>p {
      margin:0 16px;
    }
    >>>span {
      margin:0 16px;
      text-align:center;
    }

  @media screen and (min-width: 600px) {
    >>>img {
          margin:12px;
    }

  }
</style>
